import { EditListPopup, PopupComponent, PopupElements } from './edit-list-popup';
import { ActionCreator, AjaxDispatcher } from "./ajax-dispatcher";
import { initPersonEdit } from './main';


export default class PersonEdit {
    init(): void {
        const popupElements: PopupElements = {
            addItemButton: null,
            editButtons: Array.from(document.querySelectorAll('[data-action="EditPerson"]')),
            deleteButtons: []
        };
    
        const popupComponent: PopupComponent = {
            displayComponentName: 'CustomerPersonForm',
            removeItemUrl: null,
            addItemUrlParameters: [
            ],
            editItemUrlParameters: [
                { fieldName: 'personId', dataAttributeTargetValue: 'data-person-id'}
            ],
            removeItemUrlParameters: [
            ]
        };
    
        new EditListPopup().init('PersonForm', 'person-form-popup', popupElements, popupComponent, () => this.onFormSubmit());
    }

    private onFormSubmit(): void {
        const action = new ActionCreator().reloadComponent('CustomerPersonInformation');
        action.successAction = () => initPersonEdit();
        new AjaxDispatcher().dispatchGetAction(action);
    }
}
